import React, { Component} from 'react';
import PropTypes from "prop-types";
import { Translation } from 'react-i18next';

import { connect } from "react-redux";
import {
  fetchSocialLinksList,
  applySocialLinkDrag,
  clearCreateSocialLink,
  clearPatchSocialLink,
  clearDeleteSocialLink,
  clearSocialLinkDrag,
} from 'redux/social/actions';

import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";
import { Loader } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import SocialLinksListItem
  from 'components/dashboard/social-content/SocialLinksListItem';
import SocialLinksEmptyPlaceholder
  from 'components/dashboard/social-content/SocialLinksEmptyPlaceholder';
import CommonMessage from 'components/common/CommonMessage';

import './SocialLinksList.css';


class SocialLinksList extends Component {
  static propTypes = {
    fetchSocialLinksList: PropTypes.func.isRequired,
    applySocialLinkDrag: PropTypes.func.isRequired,
    clearCreateSocialLink: PropTypes.func.isRequired,
    clearPatchSocialLink: PropTypes.func.isRequired,
    clearDeleteSocialLink: PropTypes.func.isRequired,
    clearSocialLinkDrag: PropTypes.func.isRequired,
    socialNetworksList: PropTypes.arrayOf(PropTypes.shape),
    socialLinksList: PropTypes.arrayOf(PropTypes.shape),
    socialLinksListError: PropTypes.object,
    createSocialLinkSuccess: PropTypes.object,
    patchSocialLinkSuccess: PropTypes.object,
    deleteSocialLinkSuccess: PropTypes.object,
    socialLinkDrugSuccess: PropTypes.object,
    me: PropTypes.object,
  };

  static defaultProps = {
    socialNetworksList: null,
    socialLinksList: null,
    socialLinksListError: null,
    createSocialLinkSuccess: null,
    patchSocialLinkSuccess: null,
    deleteSocialLinkSuccess: null,
    socialLinkDrugSuccess: null,
    me: null,
  };

  state = {
    items: null,
  };

  componentDidMount() {
    this.setState({ items: this.props.socialLinksList });
  }

  componentDidUpdate(prevProps) {
    // Set Current List
    if (prevProps.socialLinksList !== this.props.socialLinksList) {
      this.setState({ items: this.props.socialLinksList });
    }

    // Create
    if (
      !prevProps.createSocialLinkSuccess &&
      prevProps.createSocialLinkSuccess !== this.props.createSocialLinkSuccess
    ) {
      this.props.fetchSocialLinksList();
      this.props.clearCreateSocialLink();
    }

    // Patch
    if (
      !prevProps.patchSocialLinkSuccess &&
      prevProps.patchSocialLinkSuccess !== this.props.patchSocialLinkSuccess
    ) {
      this.props.fetchSocialLinksList();
      this.props.clearPatchSocialLink();
    }

    // Delete
    if (
      !prevProps.deleteSocialLinkSuccess &&
      prevProps.deleteSocialLinkSuccess !== this.props.deleteSocialLinkSuccess
    ) {
      this.props.fetchSocialLinksList();
      this.props.clearDeleteSocialLink();
    }

    // Drag
    if (
      !prevProps.socialLinkDrugSuccess &&
      prevProps.socialLinkDrugSuccess !== this.props.socialLinkDrugSuccess
    ) {
      this.props.fetchSocialLinksList();
      this.props.clearSocialLinkDrag();
    }
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const items = this.reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({ items }, () => {
      const form = new FormData();
      this.state.items.map(item => item.id)
        .forEach(item => form.append('order', item));
      this.props.applySocialLinkDrag(form);
    });
  };

  renderSocialLinksList = () => {
    const { items } = this.state;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {provided => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {items && items.map((item, index) => (
                <Draggable
                  key={`${item.id}`}
                  draggableId={`${item.id}`}
                  index={index}
                >
                  {provided => (
                    <div
                      className="list-wrapper"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <SocialLinksListItem
                        key={`social-link-list-item-key-${item.id}`}
                        item={item}
                        socialNetworksList={this.props.socialNetworksList}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const { me, socialLinksList, socialLinksListError } = this.props;
    const { items } = this.state;

    if (socialLinksList && socialLinksList.length === 0) {
      return <SocialLinksEmptyPlaceholder />;
    }

    return (
      <Translation>
        {(t) => (
          <div className="social-links-list__component">
            <div className="title-wrapper">
              <div className="title">{t("SOCIAL LINKS")}</div>
              {(me && me.subscription && !me.subscription.ff_social_links_custom_label) ?
                <div className="text-wrapper">
                  <div className="icon-lock" />
                  <div className="text">
                    {t("You can change any Social Link title on the PRO plan.")} {t("Upgrade")} <Link to="/billing">{t("here")}</Link>
                  </div>
                </div>
                :
                <div className="text-wrapper">
                  <div className="text">
                    {t("You are PRO!")} {t("You can edit any social link title")}
                  </div>
                </div>
              }
            </div>

            {/* Loader */}
            {!socialLinksList && !socialLinksListError &&
              <Loader active />
            }

            {/* Social Links List */}
            {items && items.length > 0 &&
              this.renderSocialLinksList()
            }

            {/* Social Links Error */}
            {socialLinksListError &&
              <CommonMessage
                error
                errors={socialLinksListError}
              />
            }
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    socialNetworksList: state.socialReducer.socialNetworksList,
    socialLinksList: state.socialReducer.socialLinksList,
    socialLinksListError: state.socialReducer.socialLinksListError,
    createSocialLinkSuccess: state.socialReducer.createSocialLinkSuccess,
    patchSocialLinkSuccess: state.socialReducer.patchSocialLinkSuccess,
    deleteSocialLinkSuccess: state.socialReducer.deleteSocialLinkSuccess,
    socialLinkDrugSuccess: state.socialReducer.socialLinkDrugSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchSocialLinksList,
    applySocialLinkDrag,
    clearCreateSocialLink,
    clearPatchSocialLink,
    clearDeleteSocialLink,
    clearSocialLinkDrag,
  },
)(SocialLinksList);
